import(/* webpackMode: "eager" */ "/vercel/path0/app/blog/blog.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["Stack"] */ "/vercel/path0/lib/client-react-bootstrap.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next/dist/client/link.js");
